import StringHelpers from "./StringHelpers.js";

class QuerystringHelpers {
    constructor() {
        this.stringHelpers = new StringHelpers();
    }
    // ignoreParameter is optional. It can be used to form urls for navigation where one parameter must be different than current url
    getCurrentUrlBasedOnQueryObject(queryObject, ignoreParameter) {
        var objectLength = Object.keys(queryObject).length;
        var queryString = "";
        if (objectLength > 0) {
            queryString = "?";
        }

        var currentIncludedProperty = 0;
        for (var prop in queryObject) {
            var doIgnoreParameter = typeof ignoreParameter !== "undefined" && prop === ignoreParameter;

            if (!doIgnoreParameter && this.stringHelpers.hasValue(queryObject[prop])) {
                if (currentIncludedProperty == 0) {
                    queryString = "?";
                }
                else {
                    queryString = queryString + "&";
                }
                currentIncludedProperty++;
                queryString = queryString + prop + "=" + queryObject[prop];
            }
        }
        if (currentIncludedProperty == 0) {
            queryString = window.location.pathname;
        }
        return queryString;
    }

    pushQueryToHistory(queryObject) {
        var queryString = this.getCurrentUrlBasedOnQueryObject(queryObject);
        history.pushState(null, null, queryString + window.location.hash);
    }

    updateQueryObject(queryObject, key, value) {
        // Remove item from queryObject
        if (typeof value === 'undefined' || value === '' || !value) {
            delete queryObject[key];
        }
        // Add item from queryObject
        else {
            queryObject[key] = value;
        }
        return queryObject;
    }

    loadQueryStringAsQueryObject(_search = "") {
        var search = _search === "" ? location.search.substring(1) : _search;
        return search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
            function (key, value) { return key === "" ? value : decodeURIComponent(value); }) : {};
    }

    scrollToHash(offset = 0) {
        if (
            typeof window.location.hash != "undefined" &&
            window.location.hash != null &&
            window.location.hash != ""
        ) {
            setTimeout(function () {
                $(window).scrollTop($(window.location.hash).offset().top + offset);
            }.bind(this), 200);
        }
    }

    scrollToId(id, offset = 0) {
        var $elm = $('#' + id);
        if ($elm.length > 0) {
            setTimeout(function () {
                $(window).scrollTop($elm.offset().top + offset);
            }.bind(this), 200);
        }
    }

}

export default QuerystringHelpers;